module.exports = __webpack_public_path__ + "static/media/edu.92e8a2c4.svg";